import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Index } from "./pages/Index.tsx";
import { ModernizationReport } from "./pages/ModernizationReport";
import { Contact } from "./pages/Contact.tsx";
import { SiteForwardBadge } from "./components/ui/SiteForwardBadge.tsx";
import "./index.css";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/modernization-report" element={<ModernizationReport />} />
        </Routes>
        <SiteForwardBadge />
      </Router>
    </HelmetProvider>
  );
}

export default App;
